import { createAction } from '@reduxjs/toolkit';

export const submitSupportFormPending = createAction('support/SUBMIT_FORM/pending');
export const submitSupportFormSucceed = createAction('support/SUBMIT_FORM/succeed');
export const submitSupportFormFailed = createAction<string>('support/SUBMIT_FORM/failed');
export const resetSupportFormStatus = createAction('support/RESET_SUBMIT_STATUS');
